export default "__VITE_ASSET__2d9fec1d__"